import React from "react";
import cropr from "../shared/utils/cropr";

interface ImgCardProperties {
  imageKey: string;
  onClick?: (attachmentKey: string) => void;
  size?: 25 | 128;
  center?: boolean;
}

const ImageCard = ({ imageKey, onClick, size = 128, center = true }: ImgCardProperties) => {
  return (
    <div
      onClick={() => onClick?.(imageKey)}
      className={`attachment-thumb h-${size}px overflow-hidden ${
        center ? "bg-smoke d-flex align-items-center justify-content-center" : ""
      }`}
    >
      <img
        src={cropr.getImageUrl(imageKey, { resize: true })}
        className={`card-img-top h-${size}px w-${size}px img-cover`}
        alt="..."
      />
    </div>
  );
};
export default ImageCard;
